<template>
  <div class="search-placeholder">No posts or comments found</div>
</template>

<script>
export default {
  name: 'SearchPlaceholder',
};
</script>

<style scoped lang="scss">
.search-placeholder {
  @include caption1;

  color: var(--theme-color-text);
}
</style>
